import { combineReducers } from 'redux';
import CommonReducers from '../Reducers/commonReducers';

const Reducers = combineReducers({
    common: CommonReducers,
});

export default Reducers;